import { useEffect, useRef, useState } from 'react'
import toast from 'react-hot-toast'
import { useRecoilValue } from 'recoil'

import { uploadWorkVideo } from '@/api/room'
import { paramsState } from '@/store/room'
import { downloadImages } from '@/utils/download'

export default function Index({ url }: { url: URL }) {
  const params = useRecoilValue(paramsState)

  useEffect(() => {
    const onMessage = (event: MessageEvent) => {
      if (event.origin !== url?.origin) {
        // 替换为子页面的实际来源
        return
      }
      try {
        // 尝试解析接收到的数据
        let data: {
          action?: string
          params?: any
        } = {}
        if (typeof event.data === 'string') {
          data = JSON.parse(event.data)
        } else {
          data = event.data
        }

        console.log('🚀 ~ onMessage ~ urls:', data)
        const { action = '', params: message } = data
        switch (action) {
          case 'saveVideoToMyWork':
            if (params.lessonType === 1) {
              toast('临时教室不能保存')
              return
            }
            // 处理保存视频到我的作品的逻辑
            uploadWorkVideo({
              lessonId: params.lessonId,
              timesId: params.lessonTimeId,
              lessonType: params.lessonType,
              url: message.videoUrl,
              coverUrl: message.videoCoverUrl,
              width: message.videoCoverWidth,
              height: message.videoCoverHeight
            }).then((res) => {
              console.log('res', res)
              if (res.status === 0) {
                toast('保存作品成功')
              }
            })
            break
          case 'saveImageToMyWork':
            break
          case 'saveImagesOrVideos':
            downloadImages(message, {
              openFolderWhenDone: true,
              onCompleted: (item) => {
                console.log('下载完成:', item.filename)
              }
            })
            break
          default:
            break
        }
      } catch (error) {
        console.error('处理消息时出错:', error)
      }
    }

    window.onmessage = onMessage

    // 组件卸载时移除事件监听器
    return () => {
      window.onmessage = null
    }
  }, [url]) // 空依赖数组确保效果只运行一次

  return <div className="w-full h-full flex flex-col justify-start items-center">{url ? <iframe src={url.toString()} className="w-full h-full"></iframe> : null}</div>
}
